import axios from 'axios';
import { useState } from 'react';
import { useNotificationStore } from '../../components/notificationStore';
import { useUserStore } from '../../components/userStore';

const Preferences = () => {
	const { user, updateUser } = useUserStore();
	const { showSuccess, showError } = useNotificationStore();
	const [isUpdating, setUpdating] = useState(false);
	const [password1, setPassword1] = useState('');
	const [password2, setPassword2] = useState('');
	const isValidPassword = password1.length >= 10 && password1 === password2;

	const handleUpdatePreferences = async (updatedUser) => {
		setUpdating(true);
		try {
			await axios.patch(`/coords/${updatedUser.id}`, {
				email_notifications: updatedUser.email_notifications,
				text_notifications: updatedUser.text_notifications,
			});
			updateUser(updatedUser);
			showSuccess('Preferences updated successfully.');
		} catch (error) {
			showError('Failed to update preferences. Please try again.');
		} finally {
			setUpdating(false);
		}
	};

	const handleChangePassword = async (event) => {
		event.preventDefault();
		// TODO validation
		try {
			await axios.put(`/coords/${user.id}`, {
				password: password1,
			});
			showSuccess('Password changed');
			// clear fields
			setPassword1('');
			setPassword2('');
		} catch (err) {
			showError('Password not changed');
		}
	};

	return (
		<div className="container p-4 mx-auto preferences">
			<div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
				<div className="px-4 sm:px-0">
					<h2>Preferences</h2>
					<p className="mt-1 text-sm leading-6 text-gray-600">
						Manage your service request notification preferences.
					</p>
				</div>
				<form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
					<div className="card-body">
						<div>
							<div className="flex-row items-center gap-8 form-control">
								<label className="w-4/12 cursor-pointer label">
									<span className="label-text">Email notifications</span>
									<input
										type="checkbox"
										className="toggle toggle-primary"
										checked={user.email_notifications}
										disabled={isUpdating}
										onChange={({ target }) =>
											handleUpdatePreferences({
												...user,
												email_notifications: target.checked,
											})
										}
									/>
								</label>
								<span>{user.email_notifications ? 'On' : 'Off'}</span>
							</div>
							<div className="flex-row items-center gap-8 form-control">
								<label className="w-4/12 cursor-pointer label">
									<span className="label-text">Text notifications</span>
									<input
										type="checkbox"
										className="toggle toggle-primary"
										checked={user.text_notifications}
										disabled={isUpdating}
										onChange={({ target }) =>
											handleUpdatePreferences({
												...user,
												text_notifications: target.checked,
											})
										}
									/>
								</label>
								<span>{user.text_notifications ? 'On' : 'Off'}</span>
							</div>
						</div>
					</div>
				</form>

				<div className="px-4 sm:px-0">
					<h2>Password Reset</h2>
					<p className="mt-1 text-sm leading-6 text-gray-600">
						Reset your password and keep your account secure. Password must be
						at least 10 characters long.
					</p>
				</div>
				<form className="bg-white shadow-sm card ring-1 ring-gray-900/5 md:col-span-2">
					<div className="card-body">
						<div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
							<div className="form-control sm:col-span-3">
								<label htmlFor="password1" className="label label-text">
									New Password
								</label>
								<input
									id="password1"
									name="password1"
									type="password"
									autoComplete="new-password"
									value={password1}
									onChange={({ target }) => setPassword1(target.value)}
									required
									className="input input-sm input-bordered"
									minLength={10}
								/>
							</div>
							<div className="form-control sm:col-span-3">
								<label htmlFor="password2" className="label label-text">
									Confirm Password
								</label>
								<input
									id="password2"
									name="password2"
									type="password"
									autoComplete="new-password"
									value={password2}
									onChange={({ target }) => setPassword2(target.value)}
									required
									className="input input-sm input-bordered"
									minLength={10}
								/>
							</div>
						</div>
					</div>
					<div className="justify-end px-8 py-4 border-t card-actions border-gray-900/10">
						<button
							className="text-white btn btn-primary btn-sm"
							name="form"
							value="changePassword"
							onClick={handleChangePassword}
							disabled={!isValidPassword}
						>
							Save
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Preferences;
